import React from 'react';
import { SvgIcon } from '../../../../../../../common/react/components/SvgIcon';
import { getTranslation } from '../../../../../../../common/react/utils/translations';
export const BenchmarkingExplainer = () => (
    <div className="stats-leaders-benchmarking-explainer">
        <SvgIcon
            icon="help-circle"
            className="stats-leaders-benchmarking-explainer__icon"
        />
        { getTranslation( 'label.statsLeaders.benchmarking.explainer.tooltipTargetText' ) }
    </div>
);